<template>
  <UserForm :resource="user" :submit="submit" />
</template>

<script>
import { mapGetters } from 'vuex';

import Toastable from '@/mixins/toastable';
import ResourceService from '@/services/resources/users_service';

export default {
  mixins: [Toastable],
  components: {
    UserForm: () => import('@/components/forms/UserForm.vue'),
  },
  computed: {
    ...mapGetters('app', ['activeUser']),
  },
  asyncComputed: {
    user: {
      get() {
        return ResourceService.get(this.activeUser.id).then((user) => {
          return user.data;
        });
      },
      default: {},
    },
  },
  methods: {
    submit(user) {
      ResourceService.update(user)
        .then((result) => {
          this.successToast(`Updated the profile for ${result.data.email}`);
          this.user = result.data;
        })
        .catch(this.failToast);
    },
  },
};
</script>
